// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingSwitch":"bho_a bie_ea bie_a","LoadingSwitch__init":"bho_b bie_a bie_w bie_j bie_ul bie_um bie_fm"};